<template>
  <el-dialog
    title="选择商品订单"
    :visible.sync="dialogVisible"
    width="80%"
    top="5vh"
    @close="handleClose"
  >
    <div class="filter-container">
      <el-input
        v-model="orderId"
        placeholder="输入订单编号"
        style="width: 280px; margin-right: 10px;"
        clearable
        @keyup.enter.native="handleFilter"
      />
      <el-input
        v-model="prodName"
        placeholder="输入商品名称"
        style="width: 280px; margin-right: 10px;"
        clearable
        @keyup.enter.native="handleFilter"
      />
      <el-button type="primary" icon="el-icon-search" @click="handleFilter">
        查询
      </el-button>
    </div>

    <el-table
      :data="products"
      border
      stripe
      style="width: 100%; margin-top: 20px;"
    >
      <el-table-column label="类型" align="center" width="80">
        <template slot-scope="scope">
          {{ scope.row.cartType == '3307' ? '服务' : '商品' }}
        </template>
      </el-table-column>
      <el-table-column prop="orderId" label="订单编号" align="center" />
      <el-table-column prop="prodName" label="名称" align="center" />
      <el-table-column prop="personName" label="用户" align="center" />
      <el-table-column prop="cartNum" label="购买数量" align="center" width="100" />
      <el-table-column prop="payPrice" label="支付金额" align="center" width="100" />
      <el-table-column prop="price" label="单价" align="center" width="100" />
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleChoose(scope.row)">
            选择
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
  </el-dialog>
</template>

<script>
import { queryStoreOrderCart } from '@/api/order/stockUpStoreOrderApi'
import { getShopId } from '@/api/shop/shopApi'

/** 与 StoreOrderCartDto.getStatesAllowReturnApply() 一致 */
const RETURNABLE_CART_STATES = '3003,2002,8008,6018,3103,3104,2102'

export default {
  name: 'ChooseStoreOrderCart',
  data() {
    return {
      dialogVisible: false,
      products: [],
      orderId: '',
      prodName: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      shopId: ''
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.shopId = getShopId()
      this.currentPage = 1
      this.loadProducts()
    },
    handleClose() {
      this.orderId = ''
      this.prodName = ''
      this.products = []
      this.currentPage = 1
      this.total = 0
    },
    async loadProducts() {
      if (!this.shopId) {
        this.$message.warning('请先选择店铺')
        return
      }
      try {
        const params = {
          page: this.currentPage,
          row: this.pageSize,
          prodName: this.prodName,
          shopId: this.shopId,
          states: RETURNABLE_CART_STATES,
          orderId: this.orderId
        }
        const res = await queryStoreOrderCart(params)
        // 排除数量为 0 的行（已整行退完）
        const list = (res.data || []).filter(item => parseFloat(item.cartNum) > 0)
        this.products = list
        this.total = res.total || 0
      } catch (error) {
        console.error('查询订单商品失败:', error)
        this.$message.error('查询订单商品失败')
      }
    },
    handleFilter() {
      this.currentPage = 1
      this.loadProducts()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadProducts()
    },
    handleChoose(product) {
      this.$emit('chooseStoreOrderCart', product)
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.filter-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
